import { Button } from '@/components/ui/button';
import { ArrowRight } from '@phosphor-icons/react';
import { Testimonials } from '../Testimonials';

export const TestimonialsSection = ({ onGetStarted }) => {
  return (
    <section id="testimonials" className="py-24 px-6 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#09090B] mb-4">
            How Players Use DashLink
          </h2>
          <p className="text-lg text-[#71717A] max-w-2xl mx-auto">
            Typical ways people use the platform today.
          </p>
          <p className="mt-3 text-xs text-[#71717A]" data-testid="testimonials-disclaimer">
            These are illustrative player profiles, not quotes from real users. Verified community reviews will appear here as they come in.
          </p>
        </div>

        <Testimonials />

        <div className="text-center mt-12">
          <Button 
            onClick={onGetStarted}
            className="bg-[#0047FF] hover:bg-[#0037CC] text-white"
            data-testid="testimonials-cta"
          >
            Create Your Free Account
            <ArrowRight size={18} className="ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};
